import { getHttpStatus } from "./importErrors";
/** Tools #76358: only the publisher itself creates its new prefix, when it assigns a number. */
export var NEW_PREFIX_BY_PUBLISHER_ONLY_MESSAGE_ID = "ui-br-agency.title.products.panel.assign.reason.newPrefixByPublisherOnly";
/**
 * Maps a backend {@code assignBlockedReason} code (see the mod-br-agency
 * {@code ProductNumberAssignResponse.BlockedReason} constants) to the localized
 * message id that explains, in Czech, why a product number cannot be assigned.
 *
 * The read-only assign preview (GET /product-numbers/assign/{productId}/by-product-id)
 * returns HTTP 200 with one of these reasons instead of failing, so the assign page and
 * modal can render an explanation and disable saving rather than showing a blank page.
 */
export var ASSIGN_BLOCKED_REASON_MESSAGE_IDS = {
    PRODUCT_ALREADY_HAS_ASSIGNED_NUMBER: "ui-br-agency.product-number.assign.blocked.alreadyAssigned",
    PRODUCT_PUBLISHING_STATUS_NOT_ASSIGNABLE: "ui-br-agency.product-number.assign.blocked.publishingStatus",
    PUBLISHER_CLOSED: "ui-br-agency.product-number.assign.error.publisherClosed",
    PUBLISHER_GUARANTOR_DATA_NOT_CONFIRMED: "ui-br-agency.product-number.assign.error.confirmData",
    // RECEK-75389: every active prefix of the publisher awaits the last-used-number
    // declaration; the hint says where the declaration is entered.
    PREFIX_DECLARATION_PENDING: "ui-br-agency.title.products.panel.assign.reason.declarationPending.hint",
    NEW_PREFIX_BY_PUBLISHER_ONLY: NEW_PREFIX_BY_PUBLISHER_ONLY_MESSAGE_ID,
};
/** Generic fallback shown for an unrecognized (or newly added) blocking reason. */
export var ASSIGN_BLOCKED_GENERIC_MESSAGE_ID = "ui-br-agency.product-number.assign.blocked.generic";
/**
 * Resolve the localized message id for a blocking reason, or {@code null} when the
 * product number can be assigned (no reason present).
 *
 * @param reason the backend {@code assignBlockedReason} code, if any
 * @returns the message id to display, or {@code null} when not blocked
 */
export var getAssignBlockedReasonMessageId = function (reason) {
    var _a;
    if (!reason) {
        return null;
    }
    return ((_a = ASSIGN_BLOCKED_REASON_MESSAGE_IDS[reason]) !== null && _a !== void 0 ? _a : ASSIGN_BLOCKED_GENERIC_MESSAGE_ID);
};
/**
 * react-query {@code retry} predicate for the assign preview query: never retry a
 * client (4xx) error — those are deterministic and re-requesting only delays the error
 * pane — but keep retrying transient (network / 5xx) failures a couple of times.
 *
 * @param failureCount how many times the query has already failed
 * @param error the thrown error
 * @returns whether react-query should retry
 */
export var assignQueryRetry = function (failureCount, error) {
    var status = getHttpStatus(error);
    if (status !== undefined && status >= 400 && status < 500) {
        return false;
    }
    return failureCount < 2;
};
